const streetTypes = [
    { id: 'STREET', name: 'вулиця'},
    { id: 'AVENUE', name: 'проспект'},
    { id: 'SQUARE', name: 'площа'},
    { id: 'MAIDAN', name: 'майдан'},
    { id: 'LANE', name: 'провулок'},
    { id: 'RIVER_SIDE', name: 'набережна'},
    { id: 'BOULEVARD', name: 'бульвар'},
    { id: 'WAY', name: 'шлях'},
    { id: 'TRACT', name: 'урочище'},
    { id: 'TRACK', name: 'траса'},
    { id: 'STATION_SETTLEMENT', name: 'будинок МПС'},
    { id: 'STATION', name: 'станція'},
    { id: 'STATE_FARM', name: 'радгосп'},
    { id: 'SQUARE', name: 'площа'},
    { id: 'SMALL VILLAGE', name: 'присілок'},
    { id: 'SETTLEMENT', name: 'селище'},
    { id: 'SELECTION_BASE', name: 'селекційна станція'},
    { id: 'SANATORIUM', name: 'санаторій'},
    { id: 'ROADWAY', name: 'тракт'},
    { id: 'ROAD', name: 'дорога'},
    { id: 'PASSING_LOOP', name: 'роз\'їзд'},
    { id: 'PASSAGE', name: 'проїзд'},
    { id: 'PASS', name: 'прохід'},
    { id: 'PARK', name: 'парк'},
    { id: 'MINE', name: 'шахта'},
    { id: 'MILITARY_BASE', name: 'військова частина'},
    { id: 'MICRODISTRICT', name: 'мікрорайон'},
    { id: 'MASSIF', name: 'масив'},
    { id: 'LINE', name: 'лінія'},
    { id: 'ISLAND', name: 'острів'},
    { id: 'HOUSING_AREA', name: 'житловий масив'},
    { id: 'HIGHWAY', name: 'шосе'},
    { id: 'HAMLET', name: 'хутір'},
    { id: 'GROVE', name: 'гай'},
    { id: 'GARDEN_SQUARE', name: 'сквер'},
    { id: 'FORESTRY', name: 'лісництво'},
    { id: 'ENTRANCE', name: 'в\'їзд'},
    { id: 'DACHA_COOPERATIVE', name: 'Дачний кооператив'},
    { id: 'CROSSROADS', name: 'розвилка'},
    { id: 'COUNTRY_LANE', name: 'завулок'},
    { id: 'BOARGING_HOUSE', name: 'пансіонат'},
    { id: 'BLOCK', name: 'квартал'},
    { id: 'BLIND_STREET', name: 'тупик'},
    { id: 'ASCENT', name: 'узвіз'},
    { id: 'ALLEY', name: 'алея'}
];

export default streetTypes;
